export default {
  getRandomColors(
    count,
    { pastel = false, avoidExtremes = false, alpha = false } = {}
  ) {
    return Array.from({ length: count }, () => {
      let r, g, b;

      if (pastel) {
        r = Math.floor(Math.random() * 127 + 127);
        g = Math.floor(Math.random() * 127 + 127);
        b = Math.floor(Math.random() * 127 + 127);
      } else if (avoidExtremes) {
        r = Math.floor(Math.random() * 155 + 50);
        g = Math.floor(Math.random() * 155 + 50);
        b = Math.floor(Math.random() * 155 + 50);
      } else {
        r = Math.floor(Math.random() * 256);
        g = Math.floor(Math.random() * 256);
        b = Math.floor(Math.random() * 256);
      }
      if (alpha) {
        const a = Math.random().toFixed(2);
        return `rgba(${r}, ${g}, ${b}, ${a})`;
      } else {
        return `#${[r, g, b]
          .map((c) => c.toString(16).padStart(2, '0'))
          .join('')}`;
      }
    });
  },
};
